import { Point, SizePx } from '@/types';

export const getScaleAndOffsetForMask = (
  maskImage: HTMLImageElement,
  { width, height }: SizePx
): [Point, Point] => {
  const { naturalWidth, naturalHeight } = maskImage;
  const ratioX = width / naturalWidth;
  const ratioY = height / naturalHeight;

  const scale =
    ratioX < ratioY
      ? { x: 1, y: (ratioX * naturalHeight) / height }
      : { x: (ratioY * naturalWidth) / width, y: 1 };

  return [scale, { x: 0.5, y: 0.5 }];
};
